import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ENTER_DELAY } from 'sagas';
import { ExpandMore } from '@material-ui/icons';
import { IconButton, Popover, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useState } from 'react';
import PaymentSeriesContent from './PaymentSeriesContent';

const ANCHOR_ORIGIN = { horizontal: 'right', vertical: 'center' };
const TRANSFORM_ORIGIN = { vertical: 'center', horizontal: 'left' };

const useStyles = makeStyles((theme) => {
  const transition = {
    duration: theme.transitions.duration.standard,
  };

  return {
    div: {
      marginTop: theme.spacing(0.5),
    },
    label: {
      color: theme.palette.text.primary,
      font: 'inherit',
      fontFamily: theme.typography.fontFamily,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
    },
    opened: {
      transform: 'rotate(-90deg)',
      transition: theme.transitions.create('transform', transition),
    },
    closed: {
      transform: 'rotate(0deg)',
      transition: theme.transitions.create('transform', transition),
    },
  };
});

const PaymentSeries = ({ label, ...props }) => {
  const [anchorEl, setAnchorEl] = useState();
  const [open, setOpen] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const classes = useStyles();

  const handleTooltipClose = () => setTooltipOpen(false);
  const handleTooltipOpen = () => setTooltipOpen(!open);
  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setOpen(!open);

    if (tooltipOpen) {
      setTooltipOpen(false);
    }
  };
  const handleClose = (event) => {
    event.stopPropagation();
    setAnchorEl(null);
    setOpen(false);
  };

  return (
    <div className={classes.div}>
      <span className={classes.label}>{label}</span>
      <Tooltip
        disableFocusListener
        enterDelay={ENTER_DELAY}
        onClose={handleTooltipClose}
        onOpen={handleTooltipOpen}
        open={tooltipOpen}
        title="Show Payment Series"
      >
        <IconButton
          aria-label="Show Payment Series"
          data-testid="button"
          onClick={handleClick}
        >
          <ExpandMore
            className={classNames({
              [classes.closed]: !open,
              [classes.opened]: open,
            })}
          />
        </IconButton>
      </Tooltip>
      <Popover
        anchorEl={anchorEl}
        anchorOrigin={ANCHOR_ORIGIN}
        onClose={handleClose}
        open={open}
        transformOrigin={TRANSFORM_ORIGIN}
      >
        <PaymentSeriesContent {...props} />
      </Popover>
    </div>
  );
};

PaymentSeries.propTypes = {
  label: PropTypes.string.isRequired,
};

export default PaymentSeries;
